export class InstitucionCashModel{
    public id:number;
    public descripcion:string;
    public clave: string;
    public soporteCash: boolean;
    public cashCredito: boolean;
    public cashBackBloqueado: boolean = false;
    public cardFiCredito?: string;
    public cardFiDebito?: string;
    public prefijoBin?: string;
}
export class CatalogoModel{
    public id:number;
    public descripcion:string;
    public clave: string;
    public soporteCash?: boolean;
    public cashCredito?: boolean;
    public cardFiCredito?: string;
    public cardFiDebito?: string;
    public prefijoBin?: string;
}

export class BinManagerParams {
    
    public tipoAccion: number;
    public idBin: string;
    public url: string;
    public idTipoBin: number;
    public bin: string;
    public idInstitucion: number;
    public binManagerAdqiEmisor: BinManagerAdqEmisor;
    public origenInfo: number;
    public isRango: boolean;
    public idGrupo: number;
}

export class BinManagerAdqEmisor {
    id: number;
    bin: string;
    idTipoBin: string;
    idInstitucion: number;
    nombreInstitucion: string;
    idEstatus: number;
    estatus: string;
    idTipo: number;
    tipo: string;
    idAccion: number;
    accion: string;
    idProcesador: number;
    dscProcesador:string;
    sectorBm: number;
    numeroBm:number;
    nombreBm:string;
    entidadBm:number;
    userAlta:string;
    userMod:string;
    procedencia:string;
    adquirienteBm: AdquirienteBM;
    emisorBm:EmisorBm;
    fechaSolicitud: Date;
    origenInfo: number;
    grupo: string;
 }
 
 export class AdquirienteBM {
       idMarca: number;
       brand: string;
       pos: number;
       pagos:number;
       idInst6digit: string;
 }
 
 export class EmisorBm {
    binReferente: number;
	producto: string;
	nombreCorto: string;
	chip: number;
    idMarca: number;
	brand: string;
	acManual: number;
	puntoDeVenta: number;
	cashback: number;
	acAtm: number;
	acEcommerce: number;
	acCargos: number;
	acVentas: number;
	acSucursal: number;
	acPagos: number;
	threeSecure: number;
	binVirtual: number;
	certMarca: number;
	nfc: number;
	mst: number;
	wallet: number;
	pan: number;
	cvv_cvc: number;
	nip: number;
	tokenizado: number;
    idProducto: number;
	product: string;
    standIn: string;
    idInst6digit: string;
 }

 export class InfoBinesPendientesModel {
    total: number;
	tipoBin: string;
	indicador: string;
	idIndicador: number;
    msgIndicador: string;
 }